// Modelo Paciente para administrador.

export default class Patient {
    id=""
    identification=""
    identificationType=""
    numberHistory=""
    firstName=""
    secondName=""
    firstLastName=""
    secondLastName=""
    address=""
    addressDetail1=""
    addressDetail2=""
    addressDetail3=""
    state=""
    zone=""
    phone=""
    birthday=""
    birthdayPlace=""
    nationality=""
    culturalGroup=""
    gender=""
    civilStatus=""
    profession=""
    admitionDate=""
    company = ""
    jobCompany=""
    agencyCompany=""
    costCenter=""
    emergencyCallName=""
    emergencyRelationship=""
    emergencyAddress=""
    emergencyRelationshipPhone=""
    emergencyPhone=""
    status=true
    bloodType=""
    studies=""
    observation=""
    password=""
    religion=""
    laterality=""
    sexualOrientation=""
    disability=""
    disabilityDescription=""
    usuarioCreaActualiza=""
    ocupacion=""
}



// WEBPACK FOOTER //
// ./src/model/Patient.js